module.exports = "/static/assets/6891af6b9c97590c34cbbc234d66d24c.png";